module.exports = __webpack_public_path__ + "static/prado.min-6edd25269ddb15d29d9a6fde0fc76cc4.png";